<template>
    <navscroll v-show="showHelper" class="status-track" item-selector=".scrollactive-item" active-class="active" :offset="80" :duration="800" easing=".5,0,.35,1" :class="{'is-inview' : inView}">
        <header v-if="activeSection" class="status-track__header" @click="isOpen = !isOpen">
            <div class="status-track__item">
                <h5 class="text--orange">{{ activeSection.title }}</h5>
                <span class="account__section-tick small semi" :class="{'is-completed' : activeSection.completed === activeSection.toComplete}">
                    {{ activeSection.completed }}/{{ activeSection.toComplete }}
                    <figure>
                        <svg class="icon">
                            <use xlink:href="#tick" />
                        </svg>
                    </figure>
                </span>
            </div>
            <button>
                <svg class="icon">
                    <use v-if="isOpen" xlink:href="#close" />
                    <use v-else xlink:href="#arrow-down" />
                </svg>
            </button>
        </header>
        <div v-show="isOpen" class="status-track__main">
            <ul>
                <li v-for="(section, index) in sections" :key="index">
                    <a :href="section.id" class="status-track__item scrollactive-item">
                        <h5>{{ section.title }}</h5>
                        <span class="account__section-tick small semi" :class="{'is-completed' : section.completed === section.toComplete}">
                            {{ section.completed }}/{{ section.toComplete }}
                            <figure>
                                <svg class="icon">
                                    <use xlink:href="#tick" />
                                </svg>
                            </figure>
                        </span>
                    </a>
                </li>
            </ul>
            <div class="status-track__buttons">
                <button @click="$emit('save')">Save & Exit</button>
                <button :class="{'disabled' : !isCompleted}" @click="$emit('next')">Continue</button>
            </div>
        </div>
    </navscroll>
</template>
<script>
/* eslint-disable no-console */
export default {
    props: {
        sections: {
            type: Array,
            required: true,
        },
        isCompleted: {
            type: Boolean,
            required: true,
        },
        showHelper: {
            type: Boolean,
            required: true,
        }
    },

    data() {
        return {
            isOpen: false,
            inView: true,
        };
    },

    computed: {
        activeSection() {
            return this.sections[0];
        }
    }
}
</script>
